import React from "react"
import "./AboutUs.css"

const team = [
    {
        name: "Bhuban Padun",
        role: "Founder & Core member",
        image: "https://i.pravatar.cc/300?img=1",
    },
    {
        name: "Olum Doley",
        role: "Founder & Core member",
        image: "https://i.pravatar.cc/300?img=5",
    },
    {
        name: "Bichitra Padun",
        role: "Core member",
        image: "https://i.pravatar.cc/300?img=12",
    },
    {
        name: "Suresh Doley",
        role: "Core member",
        image: "https://i.pravatar.cc/300?img=20",
    },
];

function AboutUs() {
    return (
        <div className="about-page">

            {/* Hero */}
            <section className="hero">
                <div className="overlay">
                    <h1>About Our Company</h1>
                    <p>
                        We are an <strong>MSME-registered startup</strong> committed to transforming the education sector through innovative and reliable digital solutions. As one of the first companies in the North East region to focus exclusively on school and college management technology, we take pride in delivering modern, secure, and user-friendly software that simplifies academic and administrative operations.
                    </p>
                    <p>
                        Our mission is to empower educational institutions with smart digital tools that enhance efficiency, improve communication, and support better learning experiences. From student admissions and attendance management to examination systems, fee management, and real-time reporting, our comprehensive solutions are designed to meet the evolving needs of schools and colleges.
                    </p>
                </div>
            </section>

            {/* Story */}
            <section className="story container">
                <div className="story-text">
                    <h2>Who We Are</h2>
                    <p>
                        We are a dedicated team of software developers, technology experts, and education-focused innovators committed to transforming the way schools and colleges manage their daily operations. Our goal is to simplify administration, improve communication, and enhance the overall educational experience through reliable and user-friendly digital solutions.
                    </p>
                    <p>
                        Our comprehensive School and College Management System is designed to streamline every aspect of institutional management, including admissions, student information, attendance, examinations, fee management, staff management, transport, library, hostel, and parent communication—all within a single, secure platform.
                    </p>
                    <p>
                        With a strong focus on innovation, quality, and customer satisfaction, we help educational institutions embrace digital transformation and operate more efficiently. Our mission is to empower schools and colleges with modern technology that saves time, reduces paperwork, and enables educators to focus on what matters most—delivering quality education.
                    </p>
                </div>

                <div className="story-image">
                    <img
                        src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
                        alt=""
                    />
                </div>
            </section>

            {/* Stats */}
            <section className="stats">
                <div className="stat">
                    <h2>10+</h2>
                    <span>Projects</span>
                </div>

                <div className="stat">
                    <h2>20+</h2>
                    <span>Clients</span>
                </div>

                <div className="stat">
                    <h2>5+</h2>
                    <span>Team Members</span>
                </div>

                <div className="stat">
                    <h2>8+</h2>
                    <span>Years Experience</span>
                </div>
            </section>

            {/* Mission */}
            <section className="mission container">

                <div className="card">
                    <h3>🚀 Mission</h3>
                    <p>
                        Deliver innovative software solutions that improve businesses and
                        people's lives.
                    </p>
                </div>

                <div className="card">
                    <h3>🎯 Vision</h3>
                    <p>
                        Become a globally trusted technology company known for excellence
                        and innovation.
                    </p>
                </div>

            </section>

            {/* Values */}

            <section className="values container">
                <h2>Our Core Values</h2>

                <div className="value-grid">

                    <div className="value">
                        💡
                        <h3>Innovation</h3>
                        <p>Always creating better solutions.</p>
                    </div>

                    <div className="value">
                        ❤️
                        <h3>Passion</h3>
                        <p>Love what we build every day.</p>
                    </div>

                    <div className="value">
                        🤝
                        <h3>Integrity</h3>
                        <p>Honest, transparent and responsible.</p>
                    </div>

                    <div className="value">
                        🌍
                        <h3>Customer First</h3>
                        <p>Your success is our biggest achievement.</p>
                    </div>

                </div>

            </section>

            {/* Team */}

            <section className="team container">

                <h2>Meet Our Team</h2>

                <div className="team-grid">

                    {team.map((member) => (
                        <div className="member" key={member.name}>
                            {/* <img src={member.image} alt={member.name} /> */}
                            <h3>{member.name}</h3>
                            <span>{member.role}</span>
                        </div>
                    ))}

                </div>

            </section>

            {/* CTA */}

            <section className="cta">

                <h2>Let's Build Something Amazing Together</h2>

                <button>Contact Us</button>

            </section>

        </div>
    )
}

export default AboutUs